import React, { Component, useState, useEffect } from "react";
import { variables } from "./Variables.js";
import DeckExport from "./components/DeckExport.js";
import { rawCards } from "./data";
import { v4 as uuid } from "uuid";
import Zoom from "react-medium-image-zoom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Papa from "papaparse";
import {
  faSquareMinus,
  faSquarePlus,
  faEyeSlash,
} from "@fortawesome/free-regular-svg-icons";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  LabelList,
  ResponsiveContainer,
} from "recharts";
import html2canvas from "html2canvas";
import downloadjs from "downloadjs";

//import { DeckList } from "./DeckList";

export class Deckbuilder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cardList: [],
      firstHand: [],
      DCards: variables.deckcards,
      ICards: variables.itemcards,
      attributes: [],
      deckDisplay: [],
      itemDisplay: [],
      summaryDisplay: [],
      deckChartStats: [],
      buttonFilter: "",
      dLevel: "",
      gold: "",
      Card_Name: "",
      cardsWithoutFilter: [],
      PhotoPath: variables.PHOT_URL,
    };
  }

  changeCard_NameFilter = (e) => {
    this.state.Card_NameFilter = e.target.value;
    this.FilterFn();
  };

  button_Filter = (e) => {
    if (e.target.checked) {
      if (this.state.buttonFilter.length > 0) {
        this.state.buttonFilter += "," + e.target.value;
      } else {
        this.state.buttonFilter = e.target.value;
      }
    } else {
      if (this.state.buttonFilter.toString().includes(",")) {
        this.state.buttonFilter = this.state.buttonFilter
          .toString()
          .replace("," + e.target.value, "")
          .replace(e.target.value, "");

        if (this.state.buttonFilter.toString().startsWith(",")) {
          this.state.buttonFilter = this.state.buttonFilter.substring(1);
        }
      } else {
        this.state.buttonFilter = this.state.buttonFilter
          .toString()
          .replace(e.target.value, "");
      }
    }
    var ddisplay = document.getElementById(e.target.id);
    ddisplay.parentElement.classList.toggle("checked");

    this.state.Card_NameFilter = this.state.buttonFilter;
    this.FilterFn();
  };

  addCardtoArray = (e) => {
    //filteredData will just have the new card
    var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
      return el.Card_Name?.toString()
        .toLowerCase()
        .includes(e.toString().trim().toLowerCase());
    });
    //If the card is an item, put in item row
    if (filteredData.length > 0) {
      if (
        filteredData[0].Card_Type.toString().toLowerCase().includes("item") ||
        filteredData[0].Card_Type.toString().toLowerCase().includes("trait")
      ) {
        var ItemC = [
          {
            guid: uuid(),
            Card_Name: filteredData[0].Card_Name,
            fileloc: filteredData[0].fileloc,
            Card_Type: filteredData[0].Card_Type,
            Attribute: filteredData[0].Attribute,
            Subtype: filteredData[0].Subtype,
            Supertype: filteredData[0].Supertype,
            Cost: filteredData[0].Cost,
            Power: filteredData[0].Power,
            Focus: filteredData[0].Focus,
            Attribute_Requirement: filteredData[0].Attribute_Requirement,
            product: filteredData[0].product,
            proCount: filteredData[0].proCount,
            ID: filteredData[0].ID,
            JSN: filteredData[0].JSN,
          },
        ];
        var maxICard = this.state.ICards.filter(function (el) {
          return el.Card_Name?.toString()
            .toLowerCase()
            .includes(ItemC[0].Card_Name.toString().trim().toLowerCase());
        });
        if (maxICard.length < 3) {
          this.state.ICards.push(ItemC[0]);

          document.getElementById("goldCount").innerHTML =
            parseInt(ItemC[0].Attribute_Requirement) +
            parseInt(document.getElementById("goldCount").innerHTML);

          var newvar2 = this.state.ICards;
          variables.itemcards = newvar2;
          this.setState({ ICards: newvar2 });
          document.getElementById("itemCount").innerHTML =
            this.state.ICards.length;
          this.sortItemResult("Card_Name");
        }
      } else {
        var DeckC = [
          {
            guid: uuid(),
            Card_Name: filteredData[0].Card_Name,
            fileloc: filteredData[0].fileloc,
            Card_Type: filteredData[0].Card_Type,
            Attribute: filteredData[0].Attribute,
            Subtype: filteredData[0].Subtype,
            Supertype: filteredData[0].Supertype,
            Cost: filteredData[0].Cost,
            Power: filteredData[0].Power,
            Focus: filteredData[0].Focus,
            Attribute_Requirement: filteredData[0].Attribute_Requirement,
            product: filteredData[0].product,
            proCount: filteredData[0].proCount,
            ID: filteredData[0].ID,
            JSN: filteredData[0].JSN,
          },
        ];

        var maxCard = this.state.DCards.filter(function (el) {
          return el.Card_Name?.toString()
            .toLowerCase()
            .includes(DeckC[0].Card_Name.toString().trim().toLowerCase());
        });
        if (maxCard.length < 3) {
          this.state.DCards.push(DeckC[0]);

          var newvar2 = this.state.DCards;

          variables.deckcards = newvar2;
          this.setState({ DCards: newvar2 });

          document.getElementById("cardCount").innerHTML = parseInt(
            this.state.DCards.length
          );

          this.sortCardResult(document.getElementById("sortSelect").value);
        }
      }
      this.deckDisplay();
    }
  };

  deckDisplay() {
    var deck = variables.deckcards;
    var deckSort = deck.map((Deck) => ({
      Card_Name: Deck.Card_Name,
      fileloc: Deck.fileloc,
      Card_Type: Deck.Card_Type,
      Attribute: Deck.Attribute,
      Subtype: Deck.Subtype,
      Supertype: Deck.Supertype,
      Cost: Deck.Cost,
      Power: Deck.Power,
      Focus: Deck.Focus,
      Attribute_Requirement: Deck.Attribute_Requirement,
      product: Deck.product,
      proCount: Deck.proCount,
      Count: 0,
      ID: Deck.ID,
      JSN: Deck.JSN,
    }));

    var deckFiltered = deckSort.filter(
      (v, i, a) => a.findIndex((v2) => v2.Card_Name === v.Card_Name) === i
    );

    deckFiltered.forEach(function (i) {
      i.Count = deck.filter(
        (obj) => obj.Card_Name === i.Card_Name.toString()
      ).length;
    });
    var item = variables.itemcards;
    var itemSort = item.map((item) => ({
      Card_Name: item.Card_Name,
      fileloc: item.fileloc,
      Card_Type: item.Card_Type,
      Attribute: item.Attribute,
      Subtype: item.Subtype,
      Supertype: item.Supertype,
      Cost: item.Cost,
      Power: item.Power,
      Focus: item.Focus,
      Attribute_Requirement: item.Attribute_Requirement,
      product: item.product,
      proCount: item.proCount,
      Count: 0,
      ID: item.ID,
      JSN: item.JSN,
    }));

    var itemFiltered = itemSort.filter(
      (v, i, a) => a.findIndex((v2) => v2.Card_Name === v.Card_Name) === i
    );

    itemFiltered.forEach(function (i) {
      i.Count = item.filter(
        (obj) => obj.Card_Name === i.Card_Name.toString()
      ).length;
    });

    this.updateDeckStatsAttrib();
    this.updateDeckStatsLevel();
    this.updateDeckStats();
    this.setState({ deckDisplay: deckFiltered });
    this.setState({ itemDisplay: itemFiltered });
    this.setState({ summaryDisplay: [...itemFiltered, ...deckFiltered] });
  }

  updateDeckStatsAttrib() {
    var attributeArray = [];

    variables.deckcards.forEach(function (item) {
      if (!item.Attribute.toString().toLowerCase().includes("generic")) {
        if (item.Attribute.toString().toLowerCase().includes(",")) {
          item.Attribute.toString()
            .split(",")
            .forEach((i2) => {
              attributeArray.push(i2.trim());
            });
        } else {
          attributeArray.push(item.Attribute);
        }
      }
    });

    var uniqueAarray = [...new Set(attributeArray)];
    uniqueAarray.sort();
    this.state.attributes = uniqueAarray;
  }

  updateDeckStatsLevel() {
    var arryAttribLevel = this.state.attributes;
    var ele = document.getElementById("deckLevel");
    var ele2 = document.getElementById("totalLevel");
    var ele3 = document.getElementById("deckLevelDisplay");
    var ele4 = document.getElementById("deckLevelDisplay2");
    var ele5 = document.getElementById("deckLevel2");
    var decLevel = 0;
    ele.innerHTML = "";
    ele2.innerHTML = "";
    ele3.innerHTML = "";
    ele4.innerHTML = "";
    ele5.innerHTML = "";
    var img = document.createElement("img");
    arryAttribLevel = arryAttribLevel.filter(function (element) {
      return element !== undefined;
    });
    arryAttribLevel.sort();

    var resultArray = [];

    var result = {};

    arryAttribLevel.forEach((item) => {
      var [key, value] = item.split(" ");
      var numericalValue = parseInt(value, 10);

      // Update the key in the result object if the value is higher
      if (!result[key] || result[key] < numericalValue) {
        result[key] = numericalValue;
      }
    });

    // Populate the resultArray with objects
    for (var [key, value] of Object.entries(result)) {
      resultArray.push({ key, value: value.toString() });
    }

    resultArray.forEach(function (i, ix) {
      var maxLevel = parseInt(i.value);
      var txtAttribute = i.key.toString();
      img.src = "./assets/images/Symbols/" + txtAttribute + ".png";
      img.className = "imgNoRadius";

      if (ix === 0) {
        ele.appendChild(img);
        ele.innerHTML += txtAttribute + "/" + maxLevel;
      } else {
        ele.innerHTML += "<br/>";
        ele.appendChild(img);
        ele.innerHTML += txtAttribute + "/" + maxLevel;
      }
      for (let i2 = 0; i2 < maxLevel; i2++) {
        var crate_img = document.createElement("IMG");
        crate_img.setAttribute(
          "src",
          "./assets/images/Symbols/" + txtAttribute + "35.png"
        );
        crate_img.setAttribute("class", "imgNoRadius");
        ele3.appendChild(crate_img);
      }
      decLevel += maxLevel;
    });

    if (decLevel < 10) {
      for (let i2 = 0; i2 < 10 - decLevel; i2++) {
        var crate_img = document.createElement("IMG");
        crate_img.setAttribute("src", "./assets/images/Symbols/Generic35.png");
        crate_img.setAttribute("class", "imgNoRadius");
        ele3.appendChild(crate_img);
      }
    }
    ele4.innerHTML = ele3.innerHTML;
    ele2.innerHTML = decLevel;
    ele5.innerHTML = ele.innerHTML;
    this.setState({ dLevel: decLevel });
  }

  updateDeckStats() {
    var deckStats = document.getElementById("divDeckStats");
    deckStats.innerHTML = "";

    var deck = variables.deckcards;
    var deckLength = deck.length;
    //Number of Attacks
    var attackCount = deck.reduce(
      (acc, cur) => (cur.Supertype.includes("Attack") ? ++acc : acc),
      0
    );
    var blockCount = deck.reduce(
      (acc, cur) => (cur.Supertype.includes("Block") ? ++acc : acc),
      0
    );
    var otherCount = deck.reduce(
      (acc, cur) =>
        !cur.Supertype.includes("Block") & !cur.Supertype.includes("Attack")
          ? ++acc
          : acc,
      0
    );
    var powerAvg = 0;
    var focusAvg = 0;
    var deckInfo = [];

    if (attackCount) {
      deckStats.innerHTML = "Attack Action Count: " + attackCount;
      deckInfo.push({ Card_Type: "Attack", ID: attackCount });
    }
    //Number of Blocks
    if (blockCount) {
      deckStats.innerHTML += "<br/> Block Action Count: " + blockCount;
      deckInfo.push({ Card_Type: "Block", ID: blockCount });
    }
    //Average AP Cost
    if (otherCount) {
      deckStats.innerHTML += "<br/> Other Action Count: " + otherCount;
      deckInfo.push({ Card_Type: "Other", ID: otherCount });
    }
    this.setState({ deckChartStats: deckInfo });

    //Average Power
    var filteredData = deck.filter((e) => e.Power != "");
    powerAvg =
      filteredData.reduce(
        (r, c) => r + parseInt(c.Power.toString().replace("*", 0)),
        0
      ) / filteredData.length;
    if (powerAvg) {
      deckStats.innerHTML +=
        "<br/> Average Power: " + powerAvg.toString().substring(0, 4);
    }

    //Average Focus
    var filteredData2 = deck.filter((e) => e.Focus != "");
    focusAvg =
      filteredData2.reduce(
        (r, c) => r + parseInt(c.Focus.toString().replace("*", 0)),
        0
      ) / filteredData.length;
    if (focusAvg) {
      deckStats.innerHTML +=
        "<br/> Average Focus: " + focusAvg.toString().substring(0, 4);
    }
  }

  calcDeckStats() {
    var deck = variables.deckcards;
    var items = variables.itemcards;
    var gold = 0;
    document.getElementById("cardCount").innerHTML = deck.length;

    items.forEach(function (i) {
      gold += parseInt(i.Attribute_Requirement);
    });
    document.getElementById("goldCount").innerHTML = gold;
    document.getElementById("itemCount").innerHTML = items.length;
  }

  removeCardfromArray = (e) => {
    var deckFilterArray = this.state.DCards.filter(function (del) {
      return del.Card_Name === e;
    });

    var removedCard = deckFilterArray[0].guid.toString();

    deckFilterArray = this.state.DCards.filter(function (del) {
      return del.guid !== removedCard;
    });

    //this.updateDeckStatsLevel()

    //this.setState({DCards:deckFilterArray})
    variables.deckcards = [...deckFilterArray];
    this.state.DCards = deckFilterArray;
    document.getElementById("cardCount").innerHTML = this.state.DCards.length;
    this.deckDisplay();
  };

  removeItemfromArray = (e) => {
    var deckFilterArray = this.state.ICards.filter(function (del) {
      return del.Card_Name === e;
    });

    var removedCard = deckFilterArray[0].guid.toString();
    var removedCardCost = deckFilterArray[0].Attribute_Requirement.toString();

    if (removedCardCost) {
      document.getElementById("goldCount").innerHTML =
        parseInt(document.getElementById("goldCount").innerHTML) -
        parseInt(removedCardCost);
      document.getElementById("itemCount").innerHTML =
        this.state.ICards.length - 1;
    }

    deckFilterArray = this.state.ICards.filter(function (del) {
      return del.guid !== removedCard;
    });

    variables.itemcards = [...deckFilterArray];
    this.deckDisplay();
    this.setState({ ICards: deckFilterArray });
  };

  sortItemResult(prop) {
    var sortData = this.state.ICards;

    var sortedData = sortData.sort(function (a, b) {
      return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
    });

    this.setState({ ICards: sortedData });
  }

  sortCardResult(prop) {
    var sortData = this.state.DCards;

    var sortedData = sortData.sort(function (a, b) {
      return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
    });

    this.setState({ DCards: sortedData });
  }

  sortResult(prop, asc) {
    var sortData = this.state.deckDisplay;

    var sortedData = sortData.sort(function (a, b) {
      if (asc) {
        return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
      } else {
        return b[prop] > a[prop] ? 1 : b[prop] < a[prop] ? -1 : 0;
      }
    });

    this.setState({ deckDisplay: sortedData });
  }

  refreshList() {
    this.updateDeckStatsLevel();
    this.state.buttonFilter = "";
    this.state.Card_NameFilter = "";
    this.fetchGoogleSheetData();
  }

  FilterFn() {
    var Card_NameFilter = this.state.Card_NameFilter;
    var filterArray = Card_NameFilter.split(",");

    if (Card_NameFilter.toString().includes(",")) {
      var multiFilterArray = [];

      filterArray.forEach((i, indx) => {
        if (indx === 0) {
          if (i.toString().toLowerCase().includes("a:")) {
            i = i.replace("a:", "");
            //Attribute
            var filteredData = this.state.cardsWithoutFilter.filter(function (
              el
            ) {
              return el.Attribute?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = multiFilterArray.concat(filteredData);
          } else if (i.toString().toLowerCase().includes("ar:")) {
            //Attribute requirement
            i = i.replace("ar:", "");
            var filteredData = this.state.cardsWithoutFilter.filter(function (
              el
            ) {
              return (
                el.Attribute_Requirement?.toString()
                  .toLowerCase()
                  .startsWith(i.toString().trim().toLowerCase()) &&
                (!el.Card_Type?.toString().toLowerCase().includes("item") ||
                  !el.Card_Type?.toString().toLowerCase().includes("trait"))
              );
            });
            multiFilterArray = multiFilterArray.concat(filteredData);
          } else if (i.toString().toLowerCase().includes("gc:")) {
            //Gold cost
            i = i.replace("gc:", "");
            var filteredData = this.state.cardsWithoutFilter.filter(function (
              el
            ) {
              return (
                el.Attribute_Requirement?.toString() === i.toString() &&
                (el.Card_Type?.toString().toLowerCase().includes("item") ||
                  el.Card_Type?.toString().toLowerCase().includes("trait"))
              );
            });
            multiFilterArray = multiFilterArray.concat(filteredData);
          } else if (i.toString().toLowerCase().includes("st:")) {
            //Supertype
            i = i.replace("st:", "");
            var filteredData = this.state.cardsWithoutFilter.filter(function (
              el
            ) {
              return el.Supertype?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = multiFilterArray.concat(filteredData);
          } else if (i.toString().toLowerCase().includes("sb:")) {
            //Subtype
            i = i.replace("sb:", "");
            var filteredData = this.state.cardsWithoutFilter.filter(function (
              el
            ) {
              return el.Subtype?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = multiFilterArray.concat(filteredData);
          } else if (i.toString().toLowerCase().includes("ap:")) {
            //Cost
            i = i.replace("ap:", "");
            var filteredData = this.state.cardsWithoutFilter.filter(function (
              el
            ) {
              return el.Cost?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = multiFilterArray.concat(filteredData);
          }
        } else {
          if (i.toString().toLowerCase().includes("a:")) {
            i = i.replace("a:", "");
            //Attribute
            var filteredData2 = multiFilterArray.filter(function (el) {
              return el.Attribute?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = filteredData2;
          } else if (i.toString().toLowerCase().includes("ar:")) {
            //Attribute requirement
            i = i.replace("ar:", "");
            var filteredData2 = multiFilterArray.filter(function (el) {
              return (
                el.Attribute_Requirement?.toString()
                  .toLowerCase()
                  .startsWith(i.toString().trim().toLowerCase()) &&
                (!el.Card_Type?.toString().toLowerCase().includes("item") ||
                  !el.Card_Type?.toString().toLowerCase().includes("trait"))
              );
            });
            multiFilterArray = filteredData2;
          } else if (i.toString().toLowerCase().includes("gc:")) {
            //Gold cost
            i = i.replace("gc:", "");
            var filteredData2 = multiFilterArray.filter(function (el) {
              return (
                el.Attribute_Requirement?.toString() === i.toString() &&
                (el.Card_Type?.toString().toLowerCase().includes("item") ||
                  el.Card_Type?.toString().toLowerCase().includes("trait"))
              );
            });
            multiFilterArray = filteredData2;
          } else if (i.toString().toLowerCase().includes("st:")) {
            //Supertype
            i = i.replace("st:", "");
            var filteredData2 = multiFilterArray.filter(function (el) {
              return el.Supertype?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = filteredData2;
          } else if (i.toString().toLowerCase().includes("sb:")) {
            //Subtype
            i = i.replace("sb:", "");
            var filteredData2 = multiFilterArray.filter(function (el) {
              return el.Subtype?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = filteredData2;
          } else if (i.toString().toLowerCase().includes("ap:")) {
            //Cost
            i = i.replace("ap:", "");
            var filteredData2 = multiFilterArray.filter(function (el) {
              return el.Cost?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = filteredData2;
          } else if (i.toString().toLowerCase().includes("ct:")) {
            //Cost
            i = i.replace("ct:", "");
            var filteredData2 = multiFilterArray.filter(function (el) {
              return el.Card_Type?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = filteredData2;
          } else if (i.toString().toLowerCase().includes("txt:")) {
            //Cost
            i = i.replace("txt:", "").replace(/"/g, "");
            var filteredData2 = multiFilterArray.filter(function (el) {
              return el.Rules?.toString()
                .toLowerCase()
                .includes(i.toString().trim().toLowerCase());
            });
            multiFilterArray = filteredData2;
          }
        }
      });
      this.setState({ cardList: multiFilterArray });
    } else {
      if (Card_NameFilter.toString().toLowerCase().includes("a:")) {
        Card_NameFilter = Card_NameFilter.replace("a:", "");
        //Attribute
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Attribute?.toString()
            .toLowerCase()
            .includes(Card_NameFilter.toString().trim().toLowerCase());
        });
      } else if (Card_NameFilter.toString().toLowerCase().includes("ar:")) {
        //Attribute requirement
        Card_NameFilter = Card_NameFilter.replace("ar:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return (
            el.Attribute_Requirement?.toString()
              .toLowerCase()
              .startsWith(Card_NameFilter.toString().trim().toLowerCase()) &&
            (!el.Card_Type?.toString().toLowerCase().includes("item") ||
              !el.Card_Type?.toString().toLowerCase().includes("trait"))
          );
        });
      } else if (Card_NameFilter.toString().toLowerCase().includes("gc:")) {
        //Gold cost
        Card_NameFilter = Card_NameFilter.replace("gc:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return (
            el.Attribute_Requirement?.toString() ===
              Card_NameFilter.toString() &&
            (el.Card_Type?.toString().toLowerCase().includes("item") ||
              el.Card_Type?.toString().toLowerCase().includes("trait"))
          );
        });
      } else if (Card_NameFilter.toString().toLowerCase().includes("st:")) {
        //SuperType
        Card_NameFilter = Card_NameFilter.replace("st:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Supertype?.toString()
            .toLowerCase()
            .includes(Card_NameFilter.toString().trim().toLowerCase());
        });
      } else if (Card_NameFilter.toString().toLowerCase().includes("sb:")) {
        //Subype
        Card_NameFilter = Card_NameFilter.replace("sb:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Subtype?.toString()
            .toLowerCase()
            .startsWith(Card_NameFilter.toString().trim().toLowerCase());
        });
      } else if (Card_NameFilter.toString().toLowerCase().includes("ap:")) {
        //Subype
        Card_NameFilter = Card_NameFilter.replace("ap:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Cost?.toString()
            .toLowerCase()
            .includes(Card_NameFilter.toString().trim().toLowerCase());
        });
      } else if (Card_NameFilter.toString().toLowerCase().includes("ct:")) {
        //Card Type
        Card_NameFilter = Card_NameFilter.replace("ct:", "");
        var filteredData = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Card_Type?.toString()
            .toLowerCase()
            .includes(Card_NameFilter.toString().trim().toLowerCase());
        });
      } else {
        //Default Name/Effect
        var filteredData1 = this.state.cardsWithoutFilter.filter(function (el) {
          return el.Card_Name?.toString()
            .toLowerCase()
            .includes(Card_NameFilter.toString().trim().toLowerCase());
        });
        var filteredData2 = this.state.cardsWithoutFilter.filter(function (el) {
          return (
            el.Rules?.toString()
              .toLowerCase()
              .includes(Card_NameFilter.toString().trim().toLowerCase()) &&
            !el.Card_Name?.toString()
              .toLowerCase()
              .includes(Card_NameFilter.toString().trim().toLowerCase())
          );
        });
        var filteredData = filteredData1.concat(filteredData2);
      }
      this.setState({ cardList: filteredData });
    }
  }

  componentDidMount() {
    this.fetchGoogleSheetData();

    this.refreshList();
    var dname = variables.deckName;
    document.getElementById("dName").value = dname;

    if (variables.itemcards.length) {
      this.calcDeckStats();
    }
    if (variables.deckcards.length) {
      this.updateDeckStatsAttrib();
      this.updateDeckStatsLevel();
      this.updateDeckStats();
    }
  }

  fetchGoogleSheetData() {
    Papa.parse(
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vQbQw4rA6R54rmAj_WlkIkrkSQbPya3OZ1Yi-xHCceIGbrJHOmTFvtGKSv5ZMVQQP4T9sKebBnyMxSt/pub?output=csv",
      {
        download: true,
        header: true,
        complete: (results) => {
          const filteredData = results.data.filter(
            (row) => row.RELEASED === "TRUE"
          );
          this.setState({
            cardExcel: filteredData,
            cardList: filteredData,
            cardsWithoutFilter: filteredData,
          });
        },
      }
    );
  }

  exportDeck() {
    var list = "";
    var deck = variables.deckcards;
    var deckSort = [...new Set(deck.map((item) => item.Card_Name))];
    var deckCardCount = [];
    var items = variables.itemcards;
    var itemsSort = [...new Set(items.map((item) => item.Card_Name))];
    var itemCardCount = [];
    var level = this.state.dLevel;
    var aArray = this.state.attributes;

    aArray = aArray.filter(function (x) {
      return x !== undefined;
    });

    list += "Deck Info";
    list += "\r\nDeck Name:";
    list += "\r\n" + document.getElementById("dName").value;
    list += "\r\nBuild Level: " + level.toString();
    list += "\r\nAttributes: ";

    aArray.forEach(function (i, ix) {
      if (ix === 0) {
        list += i.toString();
      } else {
        list += ", " + i.toString();
      }
    });

    list +=
      "\r\nGold Spent " +
      document.getElementById("goldCount").innerHTML +
      "/30";

    var encodeString = "\r\n\r\nAssets\r\n";
    list += "\r\n\r\nAssets\r\n";

    itemsSort.forEach(function (i) {
      itemCardCount.push([
        i,
        items.filter((obj) => obj.Card_Name === i.toString()).length,
      ]);
      encodeString += "\r\n" + i;
      encodeString +=
        " - " + items.filter((obj) => obj.Card_Name === i.toString()).length;
      list += "\r\n" + i;
      list +=
        " - " + items.filter((obj) => obj.Card_Name === i.toString()).length;
    });
    encodeString += "\r\n\r\nActions\r\n";
    list += "\r\n\r\nActions\r\n";

    deckSort.forEach(function (i) {
      deckCardCount.push([
        i,
        deck.filter((obj) => obj.Card_Name === i.toString()).length,
      ]);
      encodeString += "\r\n" + i;
      encodeString +=
        " - " + deck.filter((obj) => obj.Card_Name === i.toString()).length;
      list += "\r\n" + i;
      list +=
        " - " + deck.filter((obj) => obj.Card_Name === i.toString()).length;
    });
    encodeString = btoa(encodeString);
    //calc decks needed
    var cardReq = [
      ...items.map((item) => item.Card_Name),
      ...deck.map((item) => item.Card_Name),
    ];
    var deckReq = [
      ...items.map((item) => item.product),
      ...deck.map((item) => item.product),
    ];
    var cardCount = [
      ...items.map((item) => item.proCount),
      ...deck.map((item) => item.proCount),
    ];

    const result = cardReq.map((name, index) => {
      return {
        Card: name,
        Deck: deckReq[index],
        Count: cardCount[index],
      };
    });

    list += "\r\n\r\n\r\n" + "Decks Required";

    var deckreqlist = "";
    var deckreqlistArray = [];
    var deckreqcardArray = [];
    result.forEach(function (i, ix) {
      deckreqcardArray.push(i);
      if (i.Deck.includes(",")) {
        var reqArray = i.Deck.toString().split(",");
        var isFounded = deckreqlistArray.some((ai) => reqArray.includes(ai));

        if (!isFounded) {
          var added = false;
          reqArray.forEach((e) => {
            if (!deckreqlistArray.includes(e) & (added === false))
              while (!added) {
                deckreqlistArray.push(reqArray[0].toString);
                deckreqlist += "\r\n" + reqArray[0].toString();
                added = true;
              }
          });
        }
      } else {
        if (
          !deckreqlist
            .toString()
            .toLowerCase()
            .includes(i.Deck.toString().toLowerCase())
        ) {
          deckreqlistArray.push(i.Deck.toString());
          deckreqlist += "\r\n" + i.Deck.toString();
        }
      }
    });

    var deckcount = 0;
    deckreqlistArray.forEach((e) => {
      deckreqcardArray.forEach((e2) => {
        console.log(e2);
      });
    });

    list += "\r\n" + deckreqlist;
    list = "Deck List String: " + encodeString + "\r\n" + list;
    var modal = document.getElementById("myModal");

    var span = document.getElementById("modalText");
    modal.style.display = "block";
    span.value = list;
  }

  shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  importDeck() {
    this.state.ICards = [];
    this.state.DCards = [];
    variables.itemcards = [];
    variables.deckcards = [];
    document.getElementById("goldCount").innerHTML = "0";
    var unencodeString = document
      .getElementById("importText")
      .value.replaceAll("’", "'");

    var textDeckList = atob(unencodeString);
    var lines = textDeckList.split("\n");
    var itemLine = lines.indexOf("Assets", 0);
    var cardLine = lines.indexOf("Actions", 0);
    var endofLine = lines.length;

    //assests
    for (let i = 0; i < lines.length; i++) {
      if (lines[i]) {
        var item = lines[i].toString().toLowerCase().split(" - ");
        var itemName = item[0].toString().trim();
        var itemCount = item[1];

        for (let i = 0; i < itemCount; i++) {
          this.addCardtoArray(itemName.toString());
        }
      }
    }

    var modal = document.getElementById("importDeck");
    var span = document.getElementById("importText");
    modal.style.display = "none";
  }

  drawHand() {
    this.setState({ firstHand: [] });
    var deck = this.state.DCards;
    var firsthan = [];

    deck.forEach(function (card, inc) {
      firsthan.push({ key: uuid(), fileloc: deck[inc].fileloc });
    });

    this.shuffle(firsthan);

    firsthan.length = 6;

    this.setState({ firstHand: firsthan });
    this.sortCardResult(document.getElementById("sortSelect").value);
  }

  closeModal() {
    var modal = document.getElementById("myModal");
    var modal2 = document.getElementById("myModal2");
    var modal3 = document.getElementById("importDeck");
    var modal4 = document.getElementById("testHand");
    var modal5 = document.getElementById("myModal3");
    var modal6 = document.getElementById("divStacks");
    var modal7 = document.getElementById("summaryScreen");
    this.setState({ firstHand: [] });
    modal.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
  }

  showTips() {
    var modal = document.getElementById("myModal2");

    modal.style.display = "block";
  }

  showStacks() {
    var modal = document.getElementById("divStacks");

    modal.style.display = "block";
  }

  hideItems() {
    var ddisplay = document.getElementById("divItemDisplay");

    ddisplay.classList.toggle("hide");
  }
  hideDeck() {
    var ddisplay = document.getElementById("divDeckDisplay");

    ddisplay.classList.toggle("hide");
  }

  showRules() {
    var modal = document.getElementById("myModal3");

    modal.style.display = "block";
  }

  copyText() {
    /* Get the text field */
    var copyText = document.getElementById("modalText");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.value);

    /* Alert the copied text */
    //alert("Copied the text: " + copyText.value);
  }

  showImport() {
    var modal3 = document.getElementById("importDeck");

    modal3.style.display = "block";
  }

  showTestHand() {
    var modal3 = document.getElementById("testHand");

    modal3.style.display = "block";
  }

  showSummaryScreen() {
    var modal3 = document.getElementById("summaryScreen");

    modal3.style.display = "block";
    var deck = this.state.deckDisplay;
  }

  saveDeckname(e) {
    variables.deckName = e.target.value;
  }

  handleChangeSort = (event) => {
    this.sortCardResult(event.target.value);
  };

  handleChangeASC = () => {
    this.sortResult(document.getElementById("sortSelect").value, true);
  };

  handleChangeDESC = () => {
    this.sortResult(document.getElementById("sortSelect").value, false);
  };

  saveDeck() {
    var item = variables.itemcards;
    var deck = variables.deckcards;
    var deckName = document.getElementById("dName").value || "VariaDeck";
    var deckData = DeckExport(this.state.cardExcel, [...item, ...deck]);

    const deckDataJson = JSON.stringify(deckData, null, 2);
    const blob = new Blob([deckDataJson], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = deckName + ".json";
    link.click();
    URL.revokeObjectURL(url);

    console.log(deckData);
  }

  showDeckStats() {
    var ddisplay = document.getElementById("deckInfoDisplay");

    ddisplay.classList.toggle("hide");
  }

  handleCaptureClick = async () => {
    var canvas = await html2canvas(document.querySelector("#summaryShot"));
    var dataURL = canvas.toDataURL("image/png");
    downloadjs(dataURL, "variaDeck.png", "image/png");
  };

  render() {
    const { cardList, firstHand, summaryDisplay, deckChartStats } = this.state;

    return (
      <>
        <div className="flex-container wide100per">
          <div id="dList" className="flex-container wide25per">
            <div className="flex-container wide100per ">
              <div
                className="flex-container card wide100per navbar navbar-expand-sm bg-dark navbar-dark"
                id="start"
              >
                <div className="pl5px pt10px wide100per">
                  <div className="gridRow2 gridCol1">
                    <input
                      id="dName"
                      placeholder="Deck Name..."
                      className="wide100per"
                      type="text"
                      onChange={this.saveDeckname}
                    ></input>
                  </div>
                  <div className="cardDock colorBG mt5px pt5px pb5px wide95per">
                    <div className="gridRow1 posRel gridCol1">
                      <span className="posAbso deckCountStyle fs22pt pt12px">
                        <span
                          className="deckCountStyle fs22pt pt12px pr3px"
                          id="cardCount"
                        >
                          0
                        </span>
                      </span>
                      <img
                        src="./assets/images/Symbols/DeckCountermid.png"
                        className="imgNoRadius"
                      />
                    </div>
                    <div className="gridRow1 gridCol2 posRel">
                      <span>
                        <span
                          className="posAbso deckCountStyle fs17pt pr3px"
                          id="itemCount"
                        >
                          0
                        </span>
                        <span
                          className="posAbso deckCountStyle fs17pt pt27px pr3px"
                          id="goldCount"
                        >
                          0
                        </span>
                      </span>
                      <img
                        src="./assets/images/Symbols/AssetCountermid.png"
                        className="imgNoRadius"
                      />
                    </div>
                    <div className="gridRow1 posRel gridCol3">
                      <div id="deckLevelDisplay"></div>
                    </div>
                    <span className="gridRow2 gridCol3 wide100per fs17pt">
                      Build Level <span id="totalLevel"></span>
                    </span>
                  </div>
                </div>
                <div className="pl5px pt10px  wide100per">
                  <div id="deckInfoDisplay" className="card-body hide">
                    <div className="gridRow1 gridCol12 wide100per pb5px pt10px">
                      <h5 className="card-title">Deck Information </h5>
                    </div>
                    <div className="gridRow2 gridCol2 wide100per pb5px pt10px">
                      <ul className="navbar-nav">
                        <li className="nav-item- m-1 textLeft">
                          <h6 className="card-subtitle mb-2">Attributes</h6>
                          <div id="deckLevel"></div>
                        </li>
                      </ul>
                    </div>
                    <div className="gridRow2 gridCol1 wide100per pb5px pt10px">
                      <div id="divDeckStats"></div>
                    </div>
                    <div className="gridRow4 wide100per pb5px pt10px">
                      <input
                        type="button"
                        className="card-link"
                        value="Export"
                        id="myBtn"
                        onClick={() => this.exportDeck()}
                      />
                      <input
                        type="button"
                        className="card-link"
                        value="Import"
                        id="myBtn2"
                        onClick={() => this.showImport()}
                      />
                      <input
                        type="button"
                        className="card-link"
                        value="Test Hand"
                        id="myBtn3"
                        onClick={() => this.showTestHand()}
                      />
                      <input
                        type="button"
                        className="card-link"
                        value="Summary"
                        id="myBtn4"
                        onClick={() => this.showSummaryScreen()}
                      />
                    </div>
                    <div className="gridRow5 wide100per pb5px pt10px">
                      <span className="wide100per pt5px">
                        Sort&nbsp;&nbsp;&nbsp;
                        <select id="sortSelect" onChange={this.handleChange}>
                          <option value="Card_Name">Name</option>
                          <option value="Cost">Action Point Cost</option>
                          <option value="Attribute">Attribute</option>
                          <option value="Supertype">Super Type</option>
                          <option value="Subtype">SubType</option>
                        </select>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <input
                          type="button"
                          className="card-link"
                          value="Asc"
                          id="myBtn4"
                          onClick={this.handleChangeASC}
                        />
                        <input
                          type="button"
                          className="card-link"
                          value="Desc"
                          id="myBtn5"
                          onClick={this.handleChangeDESC}
                        />
                      </span>
                    </div>
                  </div>
                  <label>
                    <button
                      className="btn-sm removeBtn"
                      onClick={() => this.showDeckStats()}
                    >
                      <FontAwesomeIcon icon={faEyeSlash} />
                    </button>
                  </label>
                </div>
              </div>
              <div className="h65vh overflwScroll hFC wide100per">
                <div className="borderBottomGray pb5px wide100per">
                  <div id="divItemDisplay">
                    {" "}
                    Assets
                    <br />
                    {
                      //Items
                      this.state.itemDisplay.map((ic) => (
                        <div className="cardDock" key={ic.Card_Name}>
                          <div className="textRight gridRow1 gridColumn12">
                            <Zoom
                              overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}
                            >
                              <img
                                data-internalid="1337"
                                className="wide211px partialCard"
                                src={"./assets/images/" + ic.fileloc}
                                alt={ic.Card_Name}
                              />
                            </Zoom>
                            <br />
                          </div>
                          <div className="gridRow1 gridColumn3">
                            Count: {ic.Count}
                            <br />
                            <button
                              className="btn btn-dark btn-outline-warning"
                              onClick={() =>
                                this.removeItemfromArray(ic.Card_Name)
                              }
                            >
                              <FontAwesomeIcon icon={faSquareMinus} />
                            </button>
                            <button
                              className="btn btn-dark btn-outline-warning"
                              onClick={() => this.addCardtoArray(ic.Card_Name)}
                            >
                              <FontAwesomeIcon icon={faSquarePlus} />
                            </button>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
                <div id="divDeckDisplay">
                  {
                    //Deck
                    this.state.deckDisplay.map((dc) => (
                      <div className="cardDock" key={dc.Card_Name}>
                        <div className="textRight gridRow1 gridColumn12">
                          <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                            <img
                              data-internalid="1337"
                              className="wide211px partialCard"
                              src={"./assets/images/" + dc.fileloc}
                              alt={dc.Card_Name}
                            />
                          </Zoom>
                        </div>
                        <div className="gridRow1 gridColumn3">
                          Count: {dc.Count}
                          <br />
                          <button
                            className="btn btn-dark btn-outline-warning"
                            onClick={() =>
                              this.removeCardfromArray(dc.Card_Name)
                            }
                          >
                            <FontAwesomeIcon icon={faSquareMinus} />
                          </button>
                          <button
                            className="btn btn-dark btn-outline-warning"
                            onClick={() => this.addCardtoArray(dc.Card_Name)}
                          >
                            <FontAwesomeIcon icon={faSquarePlus} />
                          </button>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          <div
            id="cList"
            className="flex-container wide75per pl10px floatRight"
          >
            <div className="flex-container wide100per floatRight h92vh overflwScroll">
              <div className="posAbosolutez10 colorBG wide73per pt10px">
                <input
                  className="btn btn-dark btn-outline-warning"
                  value={this.state.Card_NameFilter || ""}
                  onChange={this.changeCard_NameFilter}
                />
                <button
                  type="button"
                  className="btn btn-dark btn-outline-warning"
                  onClick={() => this.refreshList()}
                >
                  Reset
                </button>
                <input
                  className="btn btn-dark btn-outline-warning"
                  type="button"
                  value="Filter tips"
                  id="myBtn2"
                  onClick={() => this.showTips()}
                />
                <input
                  className="btn btn-dark btn-outline-warning"
                  type="button"
                  value="Keywords"
                  id="myBtn3"
                  onClick={() => this.showRules()}
                />
                <input
                  className="btn btn-dark btn-outline-warning"
                  type="button"
                  value="Stacks"
                  id="myBtn4"
                  onClick={() => this.showStacks()}
                />
                <div id="filterBtn" className="pt10px">
                  <label>
                    <input
                      id="aggressionSearch"
                      type="checkbox"
                      value="a:aggression"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Aggressionmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="tenacitySearch"
                      type="checkbox"
                      value="a:tenacity"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Tenacitymid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="faithSearch"
                      type="checkbox"
                      value="a:faith"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Faithmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="spiritSearch"
                      type="checkbox"
                      value="a:spirit"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Spiritmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="intellectSearch"
                      type="checkbox"
                      value="a:intellect"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Intellectmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="charismaSearch"
                      type="checkbox"
                      value="a:charisma"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Charismamid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="subtletySearch"
                      type="checkbox"
                      value="a:subtlety"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Subtletymid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="genericSearch"
                      type="checkbox"
                      value="a:generic"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Genericmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="attackSearch"
                      type="checkbox"
                      value="st:attack"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Attack Symbolmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="blockSearch"
                      type="checkbox"
                      value="st:block"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Block Symbolmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="itemSearch"
                      type="checkbox"
                      value="ct:item"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Asset Symbolmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                  <label>
                    <input
                      id="actionSearch"
                      type="checkbox"
                      value="ct:action"
                      onChange={this.button_Filter}
                    />
                    <img
                      src="./assets/images/Symbols/Action Symbolmid.png"
                      className="imgNoRadius"
                    />
                  </label>
                </div>
              </div>
              <div className="flex-container pt120px pl-10">
                {cardList.map((dep) => (
                  <div className="wide14rem h365px" key={dep.Card_Name}>
                    <div>
                      {dep.Card_Name}
                      <br />
                      <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                        <img
                          className="wide211px h295px"
                          src={"./assets/images/" + dep.fileloc}
                        />
                      </Zoom>
                    </div>
                    <input
                      type="button"
                      value="Add 1 Copy"
                      className="btn btn-dark btn-outline-warning"
                      onClick={() => this.addCardtoArray(dep?.Card_Name)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div id="myModal" className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <textarea id="modalText" className="h365px"></textarea>
            <button onClick={() => this.copyText()}>Copy text</button>
            <button onClick={() => this.saveDeck()}>Save Deck</button>
          </div>
        </div>
        <div id="myModal2" className="modal">
          <div className="modal-content mwide350">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <span id="modalText2" className="textLeft">
              You can use multiple filters at once, just seperate them with
              commas (a:faith,ap:2ap)
              <br />
              <br />
              a: Will filter for attributes, Generic will search for cards
              without any <br />
              (a:Faith)
              <br />
              ar: Will filter for attribute requirements
              <br />
              (ar:3)
              <br />
              gc: Will filter for item costs
              <br />
              (gc:20)
              <br />
              st: Will filter for Supertypes
              <br />
              (st:Physical)
              <br />
              sb: Will filter for Subtypes
              <br />
              (sb:life)
              <br />
              ap: Will filter for Action Point cost
              <br />
              (ap:2ap or ap:1life)
              <br />
              txt:"" Will search the text of a card. This is only usable when
              you are using multiple search parameters.
              <br />
              (gc:10,txt:"would")
              <br />
            </span>
          </div>
        </div>
        <div id="myModal3" className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <span id="modalText2" className=" textLeft">
              • Fast (You may Plan this Action in both the Fast Action and Fast
              Reaction steps. You may Plan this Action as a Combo or a
              Replacement.)
              <br />
              • Reach (If you began this moment engaged with your target, this
              action cannot miss due to distance.)
              <br />
              • Ranged (This action cannot miss due to distance.)
              <br />
              • Engage (Move toward your target and become engaged with them.)
              <br />
              • Disengage (Move away from your target and become disengaged from
              them.)
              <br />
              • Move (If you are currently engaged, disengage. If you are
              currently disengaged, engage.)
              <br />
              • Attribute Check (Roll 1d4+X, where X is the total attribute
              requirement of actions you’ve performed this turn. Your target
              does the same. The player with the highest total wins the check.
              You win on a tie.)
              <br />
              • Improved (When making a roll for this action, make an additional
              roll and use the higher result. If an action has both Improved and
              Impaired, the two keywords cancel each other out.)
              <br />
              • Impaired (When making a roll for this action, make an additional
              roll and use the lower result. If an action has both Improved and
              Impaired, the two keywords cancel each other out.)
              <br />
              • Spellfuse (You may create a Combo with this Action and any other
              Magical Action in your hand prior to Planning the Combined Action.
              Treat the Combined Action as a single card when it is Planned.)
              <br />
              • Skillfuse (You may create a Combo with this Action and any other
              Physical Action in your hand prior to Planning the Combined
              Action. Treat the Combined Action as a single card when it is
              Planned.)
              <br />
              • Holy Symbol (Your build cannot contain more than one holy
              symbol. Actions with Blessed will gain a benefit from this card.)
              <br />
              • Divine Enemy: [Type] (Your build cannot contain [Type] actions.
              Ex: If your divine enemy is Fire, your build cannot contain cards
              with the Fire subtype.)
              <br />
              • Blessed (Before you pay to perform this action, create a token
              that is a copy of your holy symbol’s action and combine it with
              this.)
              <br />
              • Amplify [additional cost] (When paying for this action, you may
              [pay additional] in addition to its cost. If you do, this action
              is considered amplified until end of turn.)
              <br />
              • Dragonrage (When you plan this action, you may create an Inner
              Dragon token as a combo with this action. If you do, create a
              Vulnerable token in the following moment as a replacement.)
              <br />
              • Momentum (As long as you moved in either this moment or the
              previous moment, this action will have a bonus effect.)
              <br />
              • Physical/Magical Armor: [X] (Prevent [X] damage from any
              unopposed Physical/Magical actions that damage you during the
              clash. Armors of the same type cannot overlap.Example: If you have
              Physical Armor: 2 and Physical Armor: 1, you must choose one to be
              in effect. You do not have Physical Armor: 3.)
              <br />
              <br />
            </span>
          </div>
        </div>
        <div id="importDeck" className="modal">
          <div className="modal-content wide30vwimp">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <textarea id="importText"></textarea>
            <button onClick={() => this.importDeck()}>import Deck</button>
          </div>
        </div>
        <div id="testHand" className="modal">
          <div className="modal-content wide80perImp">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <div className="flex-container">
              {firstHand.map((fhan) => (
                <div key={fhan.key}>
                  <div>
                    <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                      <img
                        className="wide211px h295px"
                        src={"./assets/images/" + fhan.fileloc}
                      />
                    </Zoom>
                  </div>
                </div>
              ))}
            </div>
            <button className="mwide350" onClick={() => this.drawHand()}>
              Draw Hand
            </button>
          </div>
        </div>
        <div id="summaryScreen" className="modal">
          <div id="summaryShot" className="modal-content wide80perImp ">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <button
              className="btn btn-dark btn-outline-warning mb20px"
              onClick={() => this.handleCaptureClick()}
            >
              Save Deck Image
            </button>
            <div className="displayGrid">
              <div className="displayGrid h190px gridRow12 gridCol1 mb20px">
                <ResponsiveContainer
                  className="gridRow12"
                  width="50%"
                  height="100%"
                >
                  <BarChart
                    width={30}
                    height={70}
                    data={deckChartStats}
                    margin={{
                      top: 0,
                      right: 0,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <XAxis dataKey="Card_Type" />
                    <YAxis />
                    <Bar dataKey="ID" fill="#82ca9d">
                      <LabelList dataKey="ID" position="top" fill="#82ca9d" />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
                <div className="gridRow12 gridCol2">
                  <div
                    id="deckLevelDisplay2"
                    className="gridRow1 gridCol1"
                  ></div>
                  <div id="deckLevel2" className="gridRow12 gridCol1"></div>
                </div>
              </div>
              <div className="flex-container gridRow2">
                {summaryDisplay.map((dd) => (
                  <div key={dd.key}>
                    <div className="summaryCount">
                      <img
                        className="wide211px h295px"
                        src={"./assets/images/" + dd.fileloc}
                      />
                      <span>{dd.Count}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div id="divStacks" className="modal">
          <div className="modal-content wide80perImp">
            <span className="close" onClick={() => this.closeModal()}>
              &times;
            </span>
            <div className="flex-container">
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Bleeding.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Charmed.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Chi.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Confused.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Dragonborne.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Enraged.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Eyes of the Goddess.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Fatigue.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Hemotoxin.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Molten.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Rooted.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Unbeatable.jpg"}
                />
              </Zoom>
              <Zoom overlayBgColorEnd={"rgba(255, 255, 255, 0.15)"}>
                <img
                  className="wide211px h295px"
                  src={"./assets/images/Stacks/Protective Coating.jpg"}
                />
              </Zoom>
            </div>
          </div>
        </div>
      </>
    );
  }
}
